import LanguageValueList from "./LanguageValueList"; // Import the new LanguageValueList class

export default class Address {
    constructor(
        street_address = new LanguageValueList(),
        administrative_area = new LanguageValueList(),
        city = new LanguageValueList(),
        postal_code = "",
        country = "",
        id = ""
    ) {
        this.street_address = street_address;
        this.administrative_area = administrative_area;
        this.city = city;
        this.postal_code = postal_code;
        this.country = country;
        this.id = id;
    }

    // Getters and Setters for each field
    getStreetAddress() {
        return this.street_address;
    }

    setStreetAddress(street_address) {
        if (street_address instanceof LanguageValueList) {
            this.street_address = street_address;
        } else {
            throw new Error("Street address must be an instance of LanguageValueList");
        }
    }

    getAdministrativeArea() {
        return this.administrative_area;
    }

    setAdministrativeArea(administrative_area) {
        if (administrative_area instanceof LanguageValueList) {
            this.administrative_area = administrative_area;
        } else {
            throw new Error("Administrative area must be an instance of LanguageValueList");
        }
    }

    getCity() {
        return this.city;
    }

    setCity(city) {
        if (city instanceof LanguageValueList) {
            this.city = city;
        } else {
            throw new Error("City must be an instance of LanguageValueList");
        }
    }

    getPostalCode() {
        return this.postal_code;
    }

    setPostalCode(postal_code) {
        this.postal_code = postal_code;
    }

    getCountry() {
        return this.country;
    }

    setCountry(country) {
        this.country = country;
    }
    getId() {
        return this.id;
    }

    setId() {
        return this.id;
    }

    // Serialize for saving
    toJSON() {
        return {
            street_address: this.street_address.toJSON(),
            administrative_area: this.administrative_area.toJSON(),
            city: this.city.toJSON(),
            postal_code: this.postal_code,
            country: this.country,
            id: this.id,
        };
    }
}
